import Repository from "../Repository";

const resource = "/spaces";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getSpace(spaceId){
        return Repository.get(`${resource}/${spaceId}`);
    },
    getSpaceTemplates(){
        return Repository.get(`${resource}?is_template=1`);
    },
    createSpace(json){
        return Repository.post(`${resource}`,json);
    },
    copySpace(spaceId){
        return Repository.post(`${resource}/${spaceId}/copy`);
    },
    updateSpace(spaceId,json){
        return Repository.put(`${resource}/${spaceId}`,json);
    },
    deleteSpace(spaceId){
        return Repository.delete(`${resource}/${spaceId}`);
    }
}